import { BlStatusEnum, ContainerStatusEnum, DocStatusEnum, FgStatusEnum, GlobalStatus, InvoiceStatusEnum, PmStatusEnum, QualityCheckStatusEnum, RmStatusEnum, SaleOrderStatusEnum, SaleStatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";
import { BomDetails } from "./bom-calculation.entity";
import { SoInvoiceDetails } from "./sale-invoice-details.entity";
import { SaleOrderItems } from "./sale-order-items.entity";
import { SaleOrder } from "./sale-order.entitiy";
import { SalePoDetails } from "./so_po_details.entity";
import {PackingStatus} from '@gtpl/shared-models/common-models'
@Entity('sale_order_track')
export class SaleOrderTrack {

  @PrimaryGeneratedColumn("increment", { name: 'so_track_id' })
  saleOrderTrackId: number;

  // @Column("int", {
  //   nullable: false,
  //   name: "sale_order_id"
  // })
  // saleOrderId: string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: ContainerStatusEnum,
    default: ContainerStatusEnum.NOT_READY,
    name: "container_status"
})
containerStatus: ContainerStatusEnum;

@Column({
    type: 'enum',
    nullable: false,
    enum: BlStatusEnum,
    default: BlStatusEnum.NOT_RECEIVED,
    name: "bl_status"
})
blStatus: BlStatusEnum;

@Column({
    type: 'enum',
    nullable: false,
    enum: DocStatusEnum,
    default: DocStatusEnum.OPEN,
    name: "doc_status"
})
DocStatus: DocStatusEnum;

@Column({
    type: 'enum',
    nullable: false,
    enum: SaleOrderStatusEnum,
    default: SaleOrderStatusEnum.OPEN,
    name: "so_status"
})
saleOrderStatus: SaleOrderStatusEnum;

@Column({
    type: 'enum',
    nullable: false,
    enum: QualityCheckStatusEnum,
    default: QualityCheckStatusEnum.OPEN,
    name: "qc_status"
})
qualityCheckStatus: QualityCheckStatusEnum;

@Column({
    type: 'enum',
    nullable: false,
    enum: PmStatusEnum,
    default: PmStatusEnum.OPEN,
    name: "pm_status"
})
pmStatus: PmStatusEnum;

@Column({
    type: 'enum',
    nullable: false,
    enum: InvoiceStatusEnum,
    default: InvoiceStatusEnum.OPEN,
    name: "invoice_status"
})
invoiceStatus: InvoiceStatusEnum;
@Column({
    type: 'enum',
    nullable: false,
    enum: InvoiceStatusEnum,
    default: InvoiceStatusEnum.OPEN,
    name: "production_status"
})
productionStatus: InvoiceStatusEnum;

@Column({
    type: 'enum',
    nullable: false,
    enum: RmStatusEnum,
    default: RmStatusEnum.OPEN,
    name: "rm_status"
})
rmStatus: RmStatusEnum;


@Column({
    type: 'enum',
    nullable: false,
    enum: FgStatusEnum,
    default: FgStatusEnum.OPEN,
    name: "fg_status"
})
fgStatus: FgStatusEnum;

@Column("boolean",{
  nullable:false,
  default:false,
  name:"is_dispatched"
  })
  isDispatched:boolean;


@Column("datetime", {
  nullable: true,
  name: "dispatched_date"
})
dispatchedDate: Date;


@Column("boolean",{
  nullable:false,
  default:false,
  name:"production_completed"
  })
  productionCompleted:boolean;

  @Column("datetime", {
    nullable: true,
    name: "prod_completed_date"
  })
  prodCompletedDate: Date;

  @Column({
    type:"decimal",
    precision:10,
    scale:3,
    nullable: true,
    name: "production_percentage",
    default:0,
    unsigned:true
  })
  productionPercentage: number;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @OneToOne(type=>SaleOrder, saleOrder=>saleOrder.soTrackData,{  nullable:false})
  @JoinColumn({ name:"sale_order_id"})
  saleOrderInfo: SaleOrder;

  @Column("boolean",{
    nullable:false,
    default:false,
    name:"is_codelist_allocated"
    })
  isCodeListAllocated:boolean;

  @Column('boolean',{
    name:'stock_in_flag',
    default:false
  })
  stockInFlag : boolean

}
